


import { Field } from "formik";
import React from "react";
import Form from "react-bootstrap/Form";

const EnquiryFive = ({ setFieldValue, errors, touched, values }) => {
  return (
    <>
      <div className="account-created-pop">
        <h3>Tell us a little more</h3>
   
        <div>
          <label>What’s the specific task?</label>
          <div className="register-form-set cmn-form-set">

            <Field as="textarea" name="taskDescription" className="w-100" placeholder="Brief description (e.g. Rewire, install lights, etc.)" rows={3} />
          </div>
          {touched.taskDescription && errors.taskDescription && (
            <div className="error-message">{errors.taskDescription}</div>
          )}
        </div>
      </div>
    </>
  );
};

export default EnquiryFive;
